import React, { Fragment } from 'react'
import { formatMoney } from 'helpers/helpers'

// Вкладка отчёта → тип в API. Меню отдаёт готовое дерево (группы с children).
// УДАЛИТЬ v1: типы menus и waiter_menus на бэкенде живут для касс старше 1.5.327;
// когда все кассы обновятся, они удаляются там, а здесь остаётся только v2.
const REPORT_API_TYPES = {
	'menus': 'menus_v2',
	'waiter_menus': 'waiter_menus_v2',
}

export function reportApiType(type) {
	return REPORT_API_TYPES[type] ?? type
}

// Группы дерева меню: родитель с подитогом и разделы под ним, корневое меню без детей — одна строка
export function renderMenuTreeRows(groups, quantityDigits) {
	return (groups || []).map((group, gIndex) => {
		if (!group.children?.length) {
			return (
				<tr key={gIndex}>
					<td className="text-start">{group.name}</td>
					<td className="text-end text-nowrap">{formatMoney(group.total_quantity, quantityDigits)}</td>
					<td className="text-end text-nowrap">{formatMoney(group.total_amount)}</td>
				</tr>
			)
		}
		return (
			<Fragment key={gIndex}>
				<tr style={{ 'backgroundColor': 'rgba(128, 128, 128, 0.12)' }}>
					<td className="text-start"><b>{group.name}</b></td>
					<td className="text-end text-nowrap"><b>{formatMoney(group.total_quantity, quantityDigits)}</b></td>
					<td className="text-end text-nowrap"><b>{formatMoney(group.total_amount)}</b></td>
				</tr>
				{group.children.map((item, index) => (
					<tr key={index}>
						<td className="text-start" style={{ 'paddingLeft': '24px' }}>{item.name}</td>
						<td className="text-end text-nowrap">{formatMoney(item.total_quantity, quantityDigits)}</td>
						<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
					</tr>
				))}
			</Fragment>
		)
	})
}

// Плоский список для Excel: родитель, затем его разделы с отступом
export function flattenMenuGroups(groups) {
	const rows = []
	for (const group of groups || []) {
		rows.push({ 'name': group.name, 'total_quantity': group.total_quantity, 'total_amount': group.total_amount })
		for (const item of group.children || []) {
			rows.push({ 'name': `    ${item.name}`, 'total_quantity': item.total_quantity, 'total_amount': item.total_amount })
		}
	}
	return rows
}
